import * as React from 'react';
import { CartProduct as ICartProduct } from '../models/interfaces';
import Input from './Input';

interface CartProductProps {
  cartProduct: ICartProduct;
  addProduct: (product: ICartProduct, amount: number) => void;
  subtractProduct: (product: ICartProduct, amount: number) => void;
  changeProductQuantity: (product: ICartProduct, quantity: number) => void;
  removeProduct: (product: ICartProduct) => void;
}

class CartProduct extends React.Component<CartProductProps> {

  constructor(props: CartProductProps) {
    super(props);
  }

  onChangeAmount(amount: number) {
    if (amount > 0) {
      this.props.addProduct(this.props.cartProduct, 1);
    } else {
      this.props.subtractProduct(this.props.cartProduct, 1);
    }
  }

  onChange(amount: string) {
    if (amount && parseInt(amount, 10) > 0) {
      this.props.changeProductQuantity(this.props.cartProduct, parseInt(amount, 10));
    }

    if (amount && parseInt(amount, 10) === 0) {
      this.props.removeProduct(this.props.cartProduct);
    }
  }

  render() {
    const { Description, UnitOfMeasure, Quantity } = this.props.cartProduct;
    const { removeProduct } = this.props;
    return (
      <div className="product">
        <div className="product__title">{Description}</div>
        <div className="product__amount">
          <div className="decrease" onClick={() => this.onChangeAmount(-1)}>-</div>
          <div className="amount">
            <Input
              id="amount"
              onChange={value => this.onChange(value)}
              type="number"
              value={Quantity}
            />
            <span className="measure">{UnitOfMeasure}</span>
          </div>
          <div className="increase" onClick={() => this.onChangeAmount(1)}>+</div>
        </div>
        <div
          className="product__remove button button--notice button--small"
          onClick={() => removeProduct(this.props.cartProduct)}
        >POISTA
        </div>
      </div>
    );
  }
}

export default CartProduct;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CartProduct.tsx